import { ADMINISTRATORS } from '../../config/app'

export function isAdmin(id: number) {
    return !!ADMINISTRATORS.find(admin => admin === id)
}
